import Raphael from 'raphael';
window.Raphael = Raphael;
